module.exports = __webpack_public_path__ + "static/img/15.932b559.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/sp/15.png
// module id = N4A4
// module chunks = 0